<h2 mat-dialog-title fxLayout="row" fxLayoutAlign="start center" *ngIf="dialogOptions.title" fxLayoutGap="8px">
    <mat-icon>{{dialogOptions.alertLevel || 'info'}}</mat-icon> <span>{{dialogOptions.title}}</span></h2>
<mat-dialog-content [innerHTML]="dialogOptions.content">
</mat-dialog-content>
<mat-dialog-actions class="pt-24" align="center">
    <button type="button" mat-raised-button mat-dialog-close color="accent">OK</button>
</mat-dialog-actions>